import React, { PureComponent } from 'react';

class PrizedInvoiceListHeader extends PureComponent {

    render() {

        return (
        	<thead className="table-header">
	            <tr className="table-list-row row-header">
	            	<th className="table-list-col bold" style={{width: '60px'}}>
	            	</th>
		            <th className="table-list-col bold">
	            	    發票號碼
	            	    <div className="fix-row-header">發票號碼</div>
	            	</th>
		            <th className="table-list-col bold">
		                期別
		                <div className="fix-row-header">期別</div>
		            </th>
		            <th className="table-list-col bold">
		                字軌
		                <div className="fix-row-header">字軌</div>
		            </th>
	            </tr>
	        </thead>
        );
    }
}

export default PrizedInvoiceListHeader;


// WEBPACK FOOTER //
// ./src/components/prizecheck/PrizedInvoiceListHeader.jsx